import { HttpApi } from "@effect/platform";
import { Configuration, Products } from "./groups";
export const Api = HttpApi.make("open-revenue-dash-api").add(Products.ProductsApi).add(Configuration.ConfigurationApi);
